/* console Promise */
import View from "./View.jsx";

export default [
  {
    path: "/project/:projectName/:isHistory?",
    controller: context => {
      return {
        component: View,
        context
      };
    }
  }
];
